import { CONSENT_STORAGE_KEY } from '~/shared/consent/consent-script';

const CONSENT_CHANGED_EVENT = 'rock:consent-changed';
export const OPEN_PREFERENCES_EVENT = 'rock:open-cookie-preferences';
const RETENTION_MS = 1000 * 60 * 60 * 24 * 365; // 12 months

const isBrowser = typeof window !== 'undefined';

export const hasGpcSignal = () => isBrowser && navigator.globalPrivacyControl === true;

export const getConsent = () => {
  if (!isBrowser) {
    return { analytics: true, ads: true, optout: false };
  }
  if (window.CGR_CONSENT) {
    return window.CGR_CONSENT;
  }
  // Fallback in case this runs before the inline head script (shouldn't happen).
  let saved = null;
  try {
    saved = JSON.parse(window.localStorage.getItem(CONSENT_STORAGE_KEY));
  } catch (error) {
    saved = null;
  }
  const gpc = hasGpcSignal();
  const consent = {
    analytics: saved ? Boolean(saved.analytics) : true,
    ads: gpc ? false : saved ? Boolean(saved.ads) : true,
    optout: gpc ? true : saved ? Boolean(saved.optout) : false,
  };
  window.CGR_CONSENT = consent;
  return consent;
};

export const applyConsent = (consent, { persist = true } = {}) => {
  if (!isBrowser) {
    return;
  }

  window.CGR_CONSENT = consent;

  if (persist) {
    try {
      window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify({ ...consent, v: 1, ts: Date.now() }));
    } catch (error) {
      // no-op — private browsing / storage disabled
    }
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'consent_update',
    consent_state: consent,
  });
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      analytics_storage: consent.analytics ? 'granted' : 'denied',
      ad_storage: consent.ads ? 'granted' : 'denied',
      ad_user_data: consent.ads ? 'granted' : 'denied',
      ad_personalization: consent.ads ? 'granted' : 'denied',
    });
  }

  window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: consent }));
};

export const onConsentChanged = (handler) => {
  if (!isBrowser) {
    return () => {};
  }
  window.addEventListener(CONSENT_CHANGED_EVENT, handler);
  return () => window.removeEventListener(CONSENT_CHANGED_EVENT, handler);
};

export const openCookiePreferences = () => {
  if (!isBrowser) {
    return;
  }
  window.dispatchEvent(new Event(OPEN_PREFERENCES_EVENT));
};

export const onOpenCookiePreferencesRequested = (handler) => {
  if (!isBrowser) {
    return () => {};
  }
  window.addEventListener(OPEN_PREFERENCES_EVENT, handler);
  return () => window.removeEventListener(OPEN_PREFERENCES_EVENT, handler);
};

export const consentRetentionMs = RETENTION_MS;
